import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ERROR_CODES } from "@/lib/error-messages";
import { Operator } from "../types/get-operators";
import { fetchOperators } from "../thunks/operator.thunks";

interface OperatorState {
  selectedOperator: string | null;
  selectedPlan: string | null;
  phoneDetails: {
    numberType: "new" | "port" | null;
    phoneNumber: string | null;
    error: string;
  };
  operators: Operator[];
  operatorsLoading: boolean;
  operatorsError: string | null;
}

const initialState: OperatorState = {
  selectedOperator: null,
  selectedPlan: null,
  phoneDetails: {
    numberType: null,
    phoneNumber: null,
    error: "",
  },
  operators: [],
  operatorsLoading: false,
  operatorsError: null,
};

const operatorSlice = createSlice({
  name: "operator",
  initialState,
  reducers: {
    setSelectedOperator: (state, action: PayloadAction<string | null>) => {
      state.selectedOperator = action.payload;
    },
    setSelectedPlan: (state, action: PayloadAction<string | null>) => {
      state.selectedPlan = action.payload;
    },
    setPhoneDetails: (
      state,
      action: PayloadAction<typeof initialState.phoneDetails>
    ) => {
      state.phoneDetails = action.payload;
    },
    resetOperator: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOperators.pending, (state) => {
        state.operatorsLoading = true;
        state.operatorsError = null;
      })
      .addCase(fetchOperators.fulfilled, (state, action) => {
        state.operatorsLoading = false;
        state.operators = action.payload;
      })
      .addCase(fetchOperators.rejected, (state) => {
        state.operatorsLoading = false;
        state.operatorsError = ERROR_CODES.FAILED_TO_FETCH_OPERATORS;
      });
  },
});

export const {
  setSelectedOperator,
  setSelectedPlan,
  setPhoneDetails,
  resetOperator,
} = operatorSlice.actions;

export default operatorSlice.reducer;
